<template>
  <div>
    <div class="panel-heading d-flex align-center py-2">
      <h4 class="panel-title">{{ $t('mobileApp.forceUpdateTitle') }}</h4>

      <div style="text-align: end">
        <v-btn
          v-if="$_has_perm('add_force_update')"
          color="primary"
          style="height: auto;"
          depressed
          @click="addNew()"
        >
          {{ $t('datatable.addNewButton') }}
        </v-btn>
      </div>
    </div>

    <div class="panel-body">
      <v-layout
        row
        wrap
      >
        <v-flex
          sm12
          md4
          lg3
          xl3
          class="px-3"
        >
          <v-text-field
            v-model="queryParams.keyword"
            :label="$t('ourAddress.searchPlaceholder')"
            @keypress.enter="getData()"
          ></v-text-field>
        </v-flex>

        <v-flex
          sm12
          md4
          lg3
          xl3
          class="px-3"
        >
          <v-select
            :items="operatingSystems"
            v-model="queryParams.operating_system"
            :label="$t('forceUpdate.operatingSystemLabel')"
            clearable
            @input="getData()"
          ></v-select>
        </v-flex>

        <v-flex
          sm12
          md4
          lg3
          xl3
          class="px-3"
        >
          <v-select
            :items="types"
            v-model="queryParams.type"
            :label="$t('columns.type')"
            clearable
            @input="getData()"
          ></v-select>
        </v-flex>
      </v-layout>

      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>{{ $t('forceUpdate.minBuildNumberColumn') }}</th>
              <th>{{ $t('columns.title') }}</th>
              <th>{{ $t('columns.description') }}</th>
              <th>{{ $t('forceUpdate.operatingSystemLabel') }}</th>
              <th>{{ $t('columns.type') }}</th>
              <th>{{ $t('columns.image') }}</th>
              <th>{{ $t('columns.createdAt') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(data, index) in apiData"
              :key="index"
            >
              <td>{{ data.build_number }}</td>
              <td>{{ data.title }}</td>
              <td>{{ data.description }}</td>
              <td>{{ data.operating_system }}</td>
              <td>{{ data.type }}</td>
              <td>
                <div
                  v-if="data.image"
                  style="width: 100px; height: 100px"
                >
                  <img
                    :src="`${$_image_path()}${data.image}`"
                    :alt="$t('columns.logo')"
                    width="100%"
                    height="100%"
                    style="border-radius: 1rem; object-fit: contain"
                  />
                </div>
              </td>
              <td>{{ data.created_at | moment('YYYY-MM-DD hh:mm a') }}</td>
              <td>
                <a
                  v-if="$_has_perm('edit_force_update')"
                  :tooltip="$t('common.edit')"
                  @click="editRow(data)"
                >
                  <v-icon color="blue darken-2">edit</v-icon>
                </a>
                <a
                  v-if="$_has_perm('delete_force_update')"
                  :tooltip="$t('common.delete')"
                  @click="deleteRow(data.force_update_id)"
                >
                  <v-icon color="red darken-2">delete</v-icon>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <add-edit
      :addEditModal="addEditModal"
      :form="form"
      :isUpdate="isUpdate"
      @close="addEditModal = false"
      @resetTable="getData()"
    />
  </div>
</template>

<script>
import Axios from 'axios'
import addEdit from './addEdit.vue'
import swal from 'sweetalert'

export default {
  components: { addEdit },
  data() {
    return {
      apiData: [],
      addEditModal: false,
      isUpdate: false,
      form: {},
      queryParams: {
        operating_system: null,
        type: null,
        keyword: null
      },
      operatingSystems: [
        { text: 'Android', value: 'android' },
        { text: 'iOS', value: 'ios' }
      ],
      types: [
        { text: this.$t('forceUpdate.softUpdateType'), value: 'soft' },
        { text: this.$t('forceUpdate.hardUpdateType'), value: 'hard' }
      ]
    }
  },

  mounted() {
    this.getData()
  },

  methods: {
    addNew() {
      this.isUpdate = false
      this.form = {
        title: null,
        description: null,
        operating_system: null,
        build_number: null,
        type: null,
        image: null,
        imageUrl: null,
        image_updated: false
      }
      this.addEditModal = true
    },

    editRow(data) {
      this.form = {
        ...data,
        imageUrl: this.$_image_path() + data.image,
        image_updated: false
      }
      this.isUpdate = true
      this.addEditModal = true
    },

    deleteRow(id) {
      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          Axios.delete(`api/force-update/${id}`, { headers: { Authorization: 'Bearer ' + token } }).then(() => {
            this.getData()
            swal({
              title: this.$t('common.deletedSuccessfully'),
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            })
          }).catch((error) => {
            swal(this.$t('common.error'), error.response.data.message, 'error')
          })
        }
      })
    },

    getData() {
      var token = localStorage.getItem('access_token')

      Axios.get('api/force-update', { params: this.queryParams, headers: { Authorization: 'Bearer ' + token } }).then(res => {
        this.apiData = res.data
      })
    }
  }
}
</script>

<style  scoped>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forceUpdate/forceUpdate.vue